import { createSlice } from '@reduxjs/toolkit';

const initialState={
    loginDetails:{},
    pmKisanData:{},
    sso:''
}

const HandleSlice=createSlice({
    name:'data',
    initialState,
    reducers:{
        // here we can make a slice for the Global State management to avoid prop drilling 
        setLoginDetails:(state,action)=>{
            state.loginDetails=action.payload
        },
        setPmKisanData:(state,action) => {     
            state.pmKisanData=action.payload
        },
        setSsoData:(state,action)=>{
            state.sso=action.payload
        },
       

    }
})
// here we can export the setFunction to  dispatch the action
export const { setLoginDetails ,setPmKisanData,setSsoData} = HandleSlice.actions;
export default HandleSlice.reducer;